import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { BsPersonCircle, BsBellFill, BsFilePersonFill, BsGearFill, BsXLg } from "react-icons/bs";
import { useAuth } from '../../contexts/AuthContext';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useNavigate } from 'react-router-dom';
import { getProfile, updatePlayer } from '../../store/auth';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../Header';
import Footer from '../../Footer';
import ChatWrapper from '../Component/ChatWrapper';
import { Modal, Button, Tooltip } from 'react-bootstrap';
import { getCharacters, addPlayerPokemon, getPokemons, getPlayerPokemons } from '../../store/pokemon';
import { Row, Col } from 'react-bootstrap';
import Loader from '../Pages/Spinner';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import PokemonProfile from '../Component/PokemonProfile';
import { getNotificationCount } from '../../store/other';
import axiosInstance from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoint';

const Home = () => {
    const [show, setShow] = useState(false);
    const { logout } = useAuth();
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const navigate = useNavigate()
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [modal, setModal] = useState(false)
    const [region, setRegion] = useState('')
    const [regionModal, setRegionModal] = useState(false)
    const userData = useSelector(state => state.auth.user_data);
    const notification_count = useSelector(state => state.other.notification_count);
    const pokemons = useSelector(state => state.pokemon.pokemons);
    const player_pokemons = useSelector(state => state.pokemon.player_pokemons);
    const characters = useSelector(state => state.pokemon.characters);
    const [current_step, setStep] = useState(1);

    const [data, setData] = useState({});
    const handleCloseModal = () => setModal(false);

    const [selectedPokemon, setSelectedPokemon] = useState(null);
    const [pokedexStats, setPokedexStats] = useState({
        caught: { percentage: 0 }
    });

    const handlePokemonClick = (pokemon, e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedPokemon(pokemon);
    }

    const closePopup = () => {
        setSelectedPokemon(null);
    };
    const handleLogout = () => {
        logout();
        localStorage.clear();
        navigate('/login')
    }
    const getProfileData = async () => {
        try {
            let user = JSON.parse(localStorage.getItem('userData') || '{}')
            
            // Check if user has a playerId
            if (!(user && user.playerId)) {
                // New user - show character/region selection modal immediately
                console.log('[HOME] New user detected - showing character selection modal');
                setData({ ...data, username: '', region: '', pokemon: '', character: '' })
                setModal(true)
                dispatch(getCharacters())
                setStep(1)
                return; // Exit early to prevent API calls
            }
            
            // Existing user - try to get profile
            try {
                let userProfile = await dispatch(getProfile()).unwrap();
                
                // Check if profile indicates no player
                if (userProfile?.data?.no_player) {
                    console.log('[HOME] Profile indicates no player - showing character selection');
                    setData({ ...data, username: '', region: '', pokemon: '', character: '' })
                    setModal(true)
                    dispatch(getCharacters())
                    setStep(1)
                    return;
                }
                
                setRegion(userProfile?.data?.wereld)
                if (userProfile.data?.eigekregen != '1') {
                    // User hasn't selected starter pokemon yet
                    setData({ ...data, username: userProfile?.data?.username, region: userProfile?.data?.wereld, pokemon: userProfile?.data?.pokemon, character: userProfile?.data?.character })
                    setModal(true)
                    dispatch(getPokemons())
                    setStep(2)
                } else {
                    // User is fully set up
                    dispatch(getPlayerPokemons())
                }
            } catch (profileError) {
                // If getProfile fails (e.g., user not found), show character selection
                console.log('[HOME] getProfile failed, showing character selection:', profileError);
                setData({ ...data, username: '', region: '', pokemon: '', character: '' })
                setModal(true)
                dispatch(getCharacters())
                setStep(1)
            }
        } catch (error) {
            console.error('[HOME] Error in getProfileData:', error);
            // On error, show character selection modal
            setData({ ...data, username: '', region: '', pokemon: '', character: '' })
            setModal(true)
            dispatch(getCharacters())
            setStep(1)
        }
    }

    const hanldedata = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    }
    const handlesubmit = async () => {
        if (current_step == 1) {

            if (!data.username) {
                toast.warning("Please enter username")
                return;
            }
            if (!data.region) {
                toast.warning("Please select region")
                return;
            }
            if (!data.character) {
                toast.warning("Please select character")
                return;
            }
            if (data.username && data.region && data.character) {
                try {
                    console.log('[HOME] Creating new player with data:', data);
                    const response = await dispatch(updatePlayer(data)).unwrap();
                    console.log('[HOME] Player creation response:', response);
                    
                    let users = JSON.parse(localStorage.getItem('userData'));
                    // Check if response has playerId and playerName
                    if (response && response.playerId) {
                        users.playerId = response.playerId;
                        console.log('[HOME] Setting playerId:', response.playerId);
                    }
                    if (response && response.playerName) {
                        users.playerName = response.playerName;
                        console.log('[HOME] Setting playerName:', response.playerName);
                    }
                    localStorage.setItem('userData', JSON.stringify(users));
                    console.log('[HOME] Updated userData in localStorage');
                    dispatch(getPokemons());
                    setStep(2);
                } catch (error) {
                    console.error('[HOME] Player creation failed:', error);
                    toast.error(error?.message || 'Failed to create player. Please try again.');
                }
            }
        } else {
            if (!data.pokemon) {
                toast.warning("Please select pokemon")
            } else {
                try {
                    await dispatch(addPlayerPokemon(data.pokemon)).unwrap()
                    dispatch(getPlayerPokemons())
                    setModal(false)
                } catch (error) {

                }
            }
        }
    }
    const handlesubmitRegion = () => {
        dispatch(updatePlayer(region))
    }
    useEffect(() => {
        getProfileData()
        dispatch(getNotificationCount())
        
        // Fetch Pokedex stats
        const fetchPokedexStats = async () => {
            try {
                const statsResponse = await axiosInstance.get(API_ENDPOINTS.GET_POKEDEX_STATS)
                if (statsResponse.data && statsResponse.data.success) {
                    setPokedexStats(statsResponse.data.data)
                }
            } catch (error) {
                console.error('Error fetching pokedex stats:', error)
            }
        }
        fetchPokedexStats()
    }, []);
    return (
        <div className='ar_mainBody'>
            {/* {profile_loading && <Loader/>} */}
            {/* <Loader/> */}
            <Modal show={regionModal} onHide={() => { setRegionModal(false) }} size='xl' contentClassName='pokemon-modal'>
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: 'white' }}>Changes Region</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6}>

                            <div className="ar_myProfile_select_area mt-3">
                                <select className="form-select" aria-label="Default select example"
                                    name="wereld"
                                    value={region}
                                    onChange={(e) => { setRegion(e.target.value) }}
                                >
                                    <option selected>Region</option>
                                    <option value="Kanto">Kanto</option>
                                    <option value="Johto">Johto</option>
                                    <option value="Hoenn">Hoenn</option>
                                    <option value="Sinnoh">Sinnoh</option>
                                    <option value="Unova">Unova</option>
                                    <option value="Kalos">Kalos</option>
                                    <option value="Alola">Alola</option>
                                </select>
                            </div>
                        </Col>
                    </Row>


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handlesubmitRegion} size='lg'>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={modal} onHide={handleCloseModal} size='xl' contentClassName='pokemon-modal' backdrop="static"
                keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{ color: 'white' }}>User Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        {current_step == 1 && <Col md={6}>
                            <div className="register-item-inner4 m-0 mt-3">
                                <input type="text"
                                    className="form-control"
                                    value={data.username}
                                    id="name"
                                    name="username"
                                    onChange={(e) => { hanldedata(e) }}
                                    placeholder={t('Usernmae')} />
                                <img src="/images/register-02.png" alt="" />
                            </div>
                        </Col>}
                        {current_step == 1 && <Col md={6}>

                            <div className="ar_myProfile_select_area mt-3 region">
                                <select className="form-select" aria-label="Default select example"
                                    name="region"
                                    value={data.region}
                                    onChange={(e) => { hanldedata(e) }}
                                >
                                    <option selected>Region</option>
                                    <option value="Kanto">Kanto</option>
                                    <option value="Johto">Johto</option>
                                    <option value="Hoenn">Hoenn</option>
                                    <option value="Sinnoh">Sinnoh</option>
                                    <option value="Unova">Unova</option>
                                    <option value="Kalos">Kalos</option>
                                    <option value="Alola">Alola</option>
                                </select>
                            </div>
                        </Col>}
                        {current_step == 1 && <Col md={12} className='p-5'>
                            <h2 >Choose your character</h2>
                            <div className='characters'>
                                <Row>
                                    {
                                        characters.map((item, index) => {
                                            return <Col md={3} sm={6} lg={2} className={`cursor-pointer d-flex flex-column justify-content-center ${data.character == item.naam ? 'character-active' : ''}`} onClick={() => { setData({ ...data, character: item.naam }) }}>
                                                <img src={`/images/characters/${item.naam}/${item.images}.png`} alt="" />
                                                <h3 className='font-weight-bold text-center'>{item.naam}</h3>
                                            </Col>
                                        })
                                    }
                                </Row>
                            </div>
                        </Col>}
                        {current_step == 2 && <Col md={12} className='p-5 '>
                            <h2 >Choose your pokemon</h2>
                            <div className='characters pokemon'>
                                <Row>
                                    {
                                        pokemons.map((item, index) => {
                                            return <Col md={3} sm={6} lg={2} className={`cursor-pointer d-flex flex-column justify-content-center ${data.pokemon == item.wild_id ? 'character-active' : ''}`} onClick={() => { setData({ ...data, pokemon: item.wild_id }) }}>
                                                <img src={`/images/pokemon/${item.wild_id}.gif`} alt="" />
                                                <h3 className='font-weight-bold text-center'>{item.naam}</h3>
                                            </Col>
                                        })
                                    }
                                </Row>
                            </div>
                        </Col>}
                    </Row>


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handlesubmit} size='lg'>
                        {current_step == 1 ? 'Next' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Modal>


            <div className='home-header'>
                <Header />
            </div>

            <div dir='rtl'>
                <div className="main-wrapper">
                    <Offcanvas show={show} onHide={handleClose} placement="end" className="bg-dark text-white custom-offcanvas-dark">
                        <Offcanvas.Header closeButton closeVariant="white">
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <div className="side-menu">
                                <ul className='p-0'>
                                    <li onClick={() => { navigate('/profile') }}><a className='d-flex justify-content-start align-items-center w-100 p-2 text-decoration-none' href="#"> <BsPersonCircle />{userData?.username}</a></li>
                                    <li onClick={() => { navigate('/notification') }}><a className='d-flex justify-content-start align-items-center w-100 p-2 text-decoration-none' href="#"> <BsBellFill />{t('Notification')} ({notification_count})</a></li>
                                    <li onClick={() => { navigate('/settings') }}><a className='d-flex justify-content-start align-items-center w-100 p-2 text-decoration-none' href="#"><BsGearFill />   {t('Settings')}</a></li>
                                    <li onClick={() => { handleLogout() }}><a className='d-flex justify-content-start align-items-center w-100 p-2 text-decoration-none' href="#" ><BsXLg />{t('Logout')} </a></li>
                                </ul>
                            </div>
                        </Offcanvas.Body>
                    </Offcanvas>

                    <section className="character-area  container">
                        <div className="container">
                            <div className="character-item">
                                <div className="character-item-inner">
                                    <div className="mock-item-inner">
                                        <ul>
                                            <li><img src="/images/mock-03.png" alt="" onClick={() => navigate('/packages?buy=silvers')} /><span style={{direction:'ltr'}}>{userData?.silver}</span><img src="/images/mock-05.png" alt="" /></li>
                                            <li><img src="/images/mock-03.png" alt="" onClick={() => navigate('/packages?buy=golds')} /><span style={{direction:'ltr'}}>{userData?.gold}</span><img src="/images/mock-04.png" alt="" /></li>
                                        </ul>
                                    </div>
                                    <div className="character-item-inner2">
                                        <ul>
                                            <li data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample" onClick={handleShow}>
                                                <img src="/images/character-01.png" alt="" />
                                            </li>
                                            <li onClick={() => navigate('/fortune')}><img src="/images/character-02.png" alt="" /><span>{t('Daily Gift')}</span></li>
                                            <li onClick={() => { navigate('/works') }}><img src="/images/character-03.png" alt="" /><span>{t('Works')}</span></li>
                                            <li><img src="/images/character-04.png" onClick={() => navigate('/inbox')} alt="" /><span>{t('Inbox')}</span></li>
                                        </ul>
                                    </div>
                                    <div className="character-item-inner3">
                                        <p><span>{userData?.verloren}</span><small>L</small><span>{userData?.gewonnen}</span><small>V</small></p>
                                        <a href="#">{t('Champion Title')}</a>
                                    </div>
                                </div>
                                <div className="character-item-inner4">
                                    <div className="character-item-inner5">
                                        <div className="character-item-inner6">
                                            <div className="character-item-inner7">
                                                <div onClick={() => { setRegionModal(true) }} className='cursor-pointer'>
                                                    <h3>{userData?.wereld} <img src="/images/character-07.png" alt="" /></h3>
                                                </div>
                                                <div>
                                                    <p>{userData?.is_vip ? <span>(VIP)</span> : ''}{userData?.username}</p>
                                                </div>
                                            </div>
                                            <div className="character-item-inner8">
                                                <span style={{ width: `${Math.min(Math.max(userData?.exp_percentage || 0, 0), 100)}%` }}><small>Lv {userData?.rank}</small></span>
                                                <p>{userData?.exp_percentage || 0}%</p>
                                            </div>
                                        </div>
                                        <div className="character-item-inner9">
                                            <img src="/images/character-06.png" alt="" />
                                        </div>
                                    </div>
                                    <div className="character-item-inner10">
                                        <div className="character-item-inner11 cursor-pointer" >
                                            <div>
                                                <h2>{t('Tags')} {userData?.is_vip ? <span>[VIP]</span> : ''}</h2>
                                            </div>
                                            <div>
                                                <img src="/images/character-12.png" alt="" />
                                            </div>
                                        </div>

                                        <div className="character-item-inner11 cursor-pointer" style={{ position: 'relative' }}>
                                            <div>
                                            <a href="/extras/pokedex"><h2>{t('Pokda')} <span>[חשבון]</span></h2></a>
                                            </div>
                                            <div style={{ position: 'relative' }}>
                                                <img src="/images/Pokda.png" alt="" />
                                                <div style={{ 
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    color: 'rgb(0, 0, 0)',
                                                    background: '#ffffff',
                                                    borderRadius: '1000px',
                                                    height: '55px',
                                                    width: '55px',
                                                    alignContent: 'center',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    {pokedexStats.caught?.percentage || 0}%
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="character-item-inner13">
                                        <div>
                                            <h2>{t('Match Wins')} <span>97 Wins</span></h2>
                                        </div>
                                        <div>
                                            <img src="/images/character-14.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="character-item2">
                                <h2>{t('Teams')}</h2>
                                <form action="#" onSubmit={(e) => e.preventDefault()}>
                                    <Row className="character-item2-inner" style={{ maxHeight: '500px' }}>
                                    {
                                        (() => {
                                            // Filter only team Pokemon (opzak === 'ja') and sort by opzak_nummer
                                            const teamPokemons = (player_pokemons || [])
                                                .filter(p => p.opzak === 'ja')
                                                .sort((a, b) => (a.opzak_nummer || 0) - (b.opzak_nummer || 0));
                                            
                                            // Create array of 6 slots, each with pokemon at opzak_nummer position
                                            const teamSlots = Array(6).fill(null);
                                            teamPokemons.forEach(pokemon => {
                                                const slotIndex = (pokemon.opzak_nummer || 1) - 1; // Convert 1-6 to 0-5
                                                if (slotIndex >= 0 && slotIndex < 6) {
                                                    teamSlots[slotIndex] = pokemon;
                                                }
                                            });
                                            
                                            return teamSlots.map((item, index) => {

                                            if (item) {
                                            return (
                                                <Col key={item.wild_id} lg={2} md={4} sm={6} xs={6} className="character-item2-inner2 gap-2">
                                                <div
                                                    className={`character-item2-inner3 pokemon-gifs position-relative cursor-pointer ${item.type1 ? item.type1.toLowerCase() : ''} ${item.type2 ? item.type2.toLowerCase() : ''}`}
                                                    onClick={(e) => handlePokemonClick(item, e)}
                                                    style={{ 
                                                        overflow: 'visible',
                                                        ...(item.leven <= 0 ? { filter: 'grayscale(100%)', opacity: 0.7 } : {})
                                                    }}
                                                >
                                                    <div className="inner-cut-bg">
                                                        <img src={`images/pokemon/${item.wild_id}.gif`} alt="" />
                                                        <div 
                                                            className="character-item2-inner4 cursor-pointer"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                navigate('/pokebag');
                                                            }}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <img src="/images/character-17.png" alt="" />
                                                        </div>
                                                        <div className="character-item2-inner5 b--35">
                                                            <p>{item.naam} - Lv <span>{item.level}</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                </Col>
                                            );
                                            } else {
                                            // בלוק ריק עם כפתור הוספה
                                            return (
                                                <Col key={`empty-${index}`} lg={2} md={4} sm={6} xs={6} className="character-item2-inner2 gap-2 cursor-pointer">
                                                <div 
                                                    className="character-item2-inner3 d-flex justify-content-center align-items-center"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        navigate('/pokebag');
                                                    }}
                                                >
                                                    <a href="#" onClick={(e) => e.preventDefault()}>
                                                    <img src="/images/playerProfile/pokemon-home-add.png" alt="הוסף פוקימון" style={{ maxHeight: '230px', opacity: 1 }} />
                                                    </a>
                                                </div>
                                                </Col>
                                            );
                                            }
                                            });
                                        })()}


                                        {/* <div className="character-item2-inner2">
                                            <div className="character-item2-inner3">
                                                <img src={`images/pokemon/250.gif`} alt="" />
                                                <div className="character-item2-inner4">
                                                </div>
                                                <div className="character-item2-inner5 b--35">
                                                    <p>{t('Pikachu')} - Lv <span>2</span></p>
                                                </div>
                                            </div>
                                        </div> */}

                                    </Row>
                                </form>
                            </div>
                        </div>
                        <ChatWrapper />

                    </section>
                </div>
            </div >
            
            {/* Pokemon Details Popup Modal */}
            {selectedPokemon && (
                <div 
                    className="pokemon-popup-overlay"
                    onClick={closePopup}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}
                >
                    <div 
                        className="pokemon-popup-content card bg-dark"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'relative',
                            maxWidth: '90%',
                            maxHeight: '90%',
                            overflow: 'auto',
                            borderRadius: '10px'
                        }}
                    >
                        {/* Close Button with Image - inside card */}
                        <a 
                            href="#" 
                            className="modal_close"
                            onClick={(e) => {
                                e.preventDefault();
                                closePopup();
                            }}
                            style={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                zIndex: 10000
                            }}
                        >
                            <img src="/images/menu/popup-close-button.png" alt="Close" style={{ width: '35px', height: '35px' }} />
                        </a>
                        
                        <PokemonProfile data={selectedPokemon} />
                    </div>
                </div>
            )}
            
            <Footer />
        </div>

    );
};

export default Home
